
import { FormControl, FormDescription, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Control, UseFormWatch } from "react-hook-form";
import { FormValues } from "./types";

interface PriceTargetInputProps {
  control: Control<FormValues>;
  watch: UseFormWatch<FormValues>;
  currentGoldPrice: number | undefined;
  currentSilverPrice: number | undefined;
}

export function PriceTargetInput({ control, watch, currentGoldPrice, currentSilverPrice }: PriceTargetInputProps) {
  const selectedMetal = watch("metal");
  const currentPrice = selectedMetal === "gold" 
    ? currentGoldPrice 
    : currentSilverPrice;
  
  return (
    <FormField
      control={control}
      name="targetPrice"
      render={({ field }) => (
        <FormItem>
          <FormLabel>Prezzo Obiettivo (€)</FormLabel>
          <FormControl>
            <Input 
              type="number" 
              step="0.01" 
              placeholder="Inserisci prezzo obiettivo" 
              {...field} 
            />
          </FormControl>
          <FormDescription>
            Prezzo attuale: €{currentPrice?.toFixed(2) || "Caricamento..."}
          </FormDescription>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
